module App.Interfaces
{
    export interface IReplacementVehicleText
    {
        code: string
        description: string
    }
}